import React from "react";

const SecondaryButton = ({
  img,
  children,
  onClick,
  className,
  disabled,
  ...props
}) => {
  return (
    <button
      className={`btn  secondary-button gangsta-class-type ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {img && <img src={img} alt="primary-button" className="mb-1 me-1" />}
      {children}
    </button>
  );
};

export default SecondaryButton;
